export default __webpack_public_path__ + "static/media/close.3a1aab02.svg";